$(document).ready(function () {
  $(".productBoxSection .boxSlider").slick({
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  if (
    $(".slider-banner.custom_banner_slider").find(".slider-item-main").length >
    1
  ) {
    $(".slider-banner.custom_banner_slider").slick({
      speed: 300,
      dots: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: false,
    });
  }
  $(".productDetailWrap .thumbnail-list").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    vertical: true,
    infinite: false,
    // mobileFirst: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 750,
        settings: "unslick",
      },
    ],
  });
  $(".productDetailWrap .thumbnail-list").find(".slick-arrow").text("");
  if ($(window).width() < 768) {
    $(".product-categories-listing").slick({
      arrows: false,
      variableWidth: true,
      infinite: false,
    });
  } else {
    $(".product-categories-listing.slick-initialized").slick("unslick");
  }
});

$(window).on("resize", function () {
    if ($(window).width() < 768) {
        $(".product-categories-listing").slick({
            arrows: false,
            variableWidth: true,
            infinite: false,
        });
    } else {
        $(".product-categories-listing.slick-initialized").slick("unslick");
    }
});
$(document).ready(function () {
    $(".cart__note .field__input").hide();
    jQuery(".cart_note_label a").on("click", function (e) {
        e.preventDefault();
        jQuery(".cart__note .field__input").toggle();
    });

    $(".policy-left ul li:first-child").addClass("active");
    if ($(window).width() < 768) {
        $(".policy-section .policy-left .appended_txt").text(
            $(".policy-section ul").find("li.active").text()
        );
    }

    setTimeout(function () {
        var tab_active = decodeURIComponent($(location).attr("hash"));
        $(".policy-section .policy-left ul li a").each(function () {
            if (
                $(this).attr("data_tab") == tab_active &&
                !$(this).parent().hasClass("active")
            ) {
                $(this).trigger("click");
            }
        });
    }, 500);
    $(".policies li a").click(function () {
        var tab_active = $(this).attr("data_tab");
        $(".policy-section .policy-left ul li a").each(function () {
            if ($(this).attr("data_tab") == tab_active) {
                $(this).trigger("click");
            }
        });
    });
});

$(window).on("resize", function () {
    // Show the first tab by default
    $(".policy-stage .policy_sub").hide();
    $(".policy-stage .policy_sub:first").show();
    $(".policy-nav li:first").addClass("policy-active");
});

$(document).ready(function () {
    $(".policy-section .policy-left .appended_txt").click(function () {
        let nextElement = $(this).next("ul");
        if ($(nextElement).hasClass("active")) {
            $(nextElement).slideUp().removeClass("active");
        } else {
            $(nextElement).slideDown().addClass("active");
        }
    });

    $(".policy-left ul li a").on("click", function () {
        $(".policy-left ul li:first-child").removeClass("active");
        let $thisText = $(this).text();
        // console.log($thisText);
        $("html, body").animate({ scrollTop: 0, behavior: "smooth" });
        $(this).closest(".policy-section").find("h1").text($thisText);
        $(this).closest(".policy-inner").find(".appended_txt").text($thisText);

        $(this).parent("li.active").removeClass("active"),
            $(this)
                .parent()
                .addClass("active")
                .siblings("li")
                .removeClass("active");
        if ($(window).width() < 768) {
            $(this).parent("li.active").removeClass("active");
            $(this).closest(".policy-inner").find("ul").slideUp();
            $(this).parent().addClass("active");
        }
    });

    // Show the first tab by default
    $(".policy-stage .policy_sub").hide();
    $(".policy-stage .policy_sub:first").show();
    $(".policy-nav li:first").addClass("policy-active");

    // Change tab class and display content
    $(".policy-nav a").on("click", function (event) {
        event.preventDefault();
        $(".policy-nav li").removeClass("policy-active");
        $(this).parent().addClass("policy-active");
        $(".policy-stage .policy_sub").hide();
        $($(this).attr("href")).show();
    });

    $(".product_tile_color_holder input").mouseover(function () {
        var saved_this = $(this);
        if ($(this).attr("data-imgnew") !== null) {
            var dataaa = saved_this
                .parents(".card-wrapper")
                .find(".card__media img")
                .attr("srcset")
                .split(",");
            var arr = [];
            $.each(dataaa, function (key, value) {
                var manuall = value.split(" ");
                manuall[0] = saved_this.attr("data-imgnew");
                manuall = manuall.join(" ");
                arr.push(manuall);
            });
            console.log(arr.join(","));
            $(this)
                .parents(".card-wrapper")
                .find(".card__media img")
                .attr("src", $(this).attr("data-imgnew"));
            $(this)
                .parents(".card-wrapper")
                .find(".card__media img")
                .attr("srcset", arr);
        }
    });

    $(".custom_icon_login").click(function (e) {
        e.preventDefault();
        $("body").addClass("popup_show");
        $("#record-user-banner").show();
    });

    $("#record-user-banner svg.icon-close").click(function () {
        $("#record-user-banner").hide();
        $("body").removeClass("popup_show");
    });

    $(".main-login-pop-up svg.icon.icon-close").click(function () {
        $(".main-login-pop-up").hide();
        $("body").removeClass("popup_show");
    });

    /* $('#record-user-banner .record-user-outer button.login_btn').click(function(e){
      e.preventDefault();
      $('#record-user-banner').hide();
      $('.main-login-pop-up').show();
  }); */

    document.onkeydown = function (evt) {
        evt = evt || window.event;
        if (evt.keyCode == 27 && $("body").hasClass("popup_show")) {
            //27 is the code for escape
            $("#record-user-banner").hide();
            $(".main-login-pop-up").hide();
            $("body").removeClass("popup_show");
        }
    };

    setTimeout(function () {
        if (
            !$("body").hasClass("popup_show") &&
            $(!".header-wrapper a.header__icon.header__icon--account").hasClass(
                "custom_icon_account "
            )
        ) {
            $("body").addClass("popup_show");
            $("#record-user-banner").show();
        }
    }, 20000);
});

$(document).ready(function () {
    $(
        "#collection-page-wrapper #product-grid .collection_product_variant label"
    ).click(function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        const form = $(this).parent(".collection_product_variant").next("form");
        form.find('input[name="id"]').attr(
            "value",
            $(this).attr("data_variant_id")
        );
        form.find('button[type="submit"]').click();
    });

    // product page size js
    $(".product-page-wrapper-main .product-form__input")
        .first()
        .find("input")
        .on("change", function () {
            var color_ax = $(this).attr("value");
            $(".product_variant_size_main")
                .find("label")
                .each(function () {
                    if ($(this).hasClass(color_ax)) {
                        //console.log($(this));
                        var variant_size_ax = $(this)
                            .find(".productSize p")
                            .text();
                        var variant_price_ax = $(this)
                            .find(".produCategory p")
                            .text();
                        var variant_comp_price_ax = $(this)
                            .find(".productPrize span")
                            .text();
                        $(".variant-size-main")
                            .find("input[type=radio]")
                            .each(function () {
                                if ($(this).attr("value") == variant_size_ax) {
                                    $(this)
                                        .next("label")
                                        .find(".productPrize span")
                                        .text(variant_comp_price_ax);
                                    $(this)
                                        .next("label")
                                        .find(".produCategory p")
                                        .text(variant_price_ax);
                                }
                            });
                    }
                });
        });

    // product page sticky bar section variant change js
    $(
        '.product-page-wrapper-main .product-form__input input[name="Color"], .product-page-wrapper-main .productDetailTbl ul.variant-size-main input[type=radio]'
    ).on("change", function () {
        var selectedVariantInput = $('.product-page-wrapper-main .product-form__input input[name="Tamaño"]:checked');
        var selectedVariantLabel = selectedVariantInput.next('label');

        var isPremiumCustomer = selectedVariantLabel.data('is-premium-customer');
        var isSalesPrice = selectedVariantLabel.data('is-sales-price');
        var isPrivateSalesPrice = selectedVariantLabel.data('is-private-sales-price');

        var priceWrapper = $(".product-sticky-sec .product-sticky-left-cont");
        var salesPrice = $(".product-sticky-sec .price-item--sale.price-item--last");

        if (isPremiumCustomer) {
            priceWrapper.addClass('price--premium').removeClass('price--not-premium');
        } else {
            priceWrapper.addClass('price--not-premium').removeClass('price--premium');
        }
        if (isSalesPrice) {
            priceWrapper.addClass('price--sales');
        } else {
            priceWrapper.removeClass('price--sales');
        }
        if (isPrivateSalesPrice) {
            priceWrapper.addClass('price--private-sales');
        } else {
            priceWrapper.removeClass('price--private-sales');
        }

        var colorValue = $('.product-page-wrapper-main .product-form__input input[name="Color"]:checked').val();
        var sizeValue = selectedVariantInput.val();
        var sizeCompareAtPrice = selectedVariantLabel
            .find(".productPrize")
            .text();
        var sizePrice = selectedVariantLabel
            .find(".produCategory")
            .html();

        $(".select-dropdown.product-color-dropdown select")
            .val(colorValue)
            .trigger("change");
        $(".product-sticky-sec .product-sticky-left .select-dropdown.product-tamaño-dropdown select")
            .val(sizeValue)
            .trigger("change");
        $(".product-sticky-sec .price-item.price-item--regular")
            .text(sizeCompareAtPrice);
        salesPrice
            .html(sizePrice);

        if (isSalesPrice || isPrivateSalesPrice) {
            salesPrice.addClass('sale_color');
        } else {
            salesPrice.removeClass('sale_color');
        }

        setTimeout(function () {
            if (
                $(
                    ".productDetailWrap .product-form__buttons .product-form__submit"
                ).is(":disabled")
            ) {
                $(".product-sticky-sec .product-sticky-button").attr(
                    "disabled",
                    true
                );
                $(".product-sticky-sec .product-sticky-button").text(
                    $(
                        ".productDetailWrap .product-form__buttons .product-form__submit"
                    ).text()
                );
            } else {
                $(".product-sticky-sec .product-sticky-button").attr(
                    "disabled",
                    false
                );
                $(".product-sticky-sec .product-sticky-button").text(
                    $(
                        ".productDetailWrap .product-form__buttons .product-form__submit"
                    ).text()
                );
            }
        }, 1000);
    });

    // Product page sticky bar section variant change in sticky bar js
    $(".product-sticky-sec .select-dropdown.product-color-dropdown select").on(
        "change",
        function () {
            //console.log($(this).val());
            var BC_val = $(this).val();
            $(
                '.product-page-wrapper-main .product-form__input input[name="Color"]'
            ).each(function () {
                if ($(this).attr("value") == BC_val) {
                    $(this).trigger("click");
                }
            });
        }
    );
    $(".product-sticky-sec .select-dropdown.product-tamaño-dropdown select").on(
        "change",
        function () {
            // console.log($(this).val());
            var BS_val = $(this).val();
            $(
                ".product-page-wrapper-main .productDetailTbl ul.variant-size-main input[type=radio]"
            ).each(function () {
                if ($(this).attr("value") == BS_val) {
                    $(this).trigger("click");
                }
            });
        }
    );
});

$(document).ready(function () {
    $(".productDetailHeader .sizeGuide").click(function () {
        $(".zifyapp-sc .zify-sc-btn-open-modal").trigger("click");
    });
});

// product page sticky bar section variant change js
$(window).on("load", function () {
    // product page size js
    $(".product_variant_size_main")
        .find("label")
        .each(function () {
            var color_ax1 = $(".product-page-wrapper-main .product-form__input")
                .first()
                .find("input:checked")
                .attr("value");
            if ($(this).hasClass(color_ax1)) {
                //console.log($(this));
                var variant_size_ax = $(this).find(".productSize p").text();
                var variant_price_ax = $(this).find(".produCategory p").text();
                var variant_comp_price_ax = $(this)
                    .find(".productPrize span")
                    .text();
                $(".variant-size-main")
                    .find("input[type=radio]")
                    .each(function () {
                        if ($(this).attr("value") == variant_size_ax) {
                            $(this)
                                .next("label")
                                .find(".productPrize span")
                                .text(variant_comp_price_ax);
                            $(this)
                                .next("label")
                                .find(".produCategory p")
                                .text(variant_price_ax);
                        }
                    });
            }
        });

    var C_val = $(
        '.product-page-wrapper-main .product-form__input input[name="Color"]:checked'
    ).val();
    var S_val = $(
        '.product-page-wrapper-main .product-form__input input[name="Tamaño"]:checked'
    ).val();
    var S_comp = $(
        '.product-page-wrapper-main .product-form__input input[name="Tamaño"]:checked'
    )
        .next("label")
        .find(".productPrize")
        .text();
    var S_price = $(
        '.product-page-wrapper-main .product-form__input input[name="Tamaño"]:checked'
    )
        .next("label")
        .find(".produCategory")
        .html();
    $(".select-dropdown.product-color-dropdown select")
        .val(C_val)
        .trigger("change");
    $(
        ".product-sticky-sec .product-sticky-left .select-dropdown.product-tamaño-dropdown select"
    )
        .val(S_val)
        .trigger("change");
    $(".product-sticky-sec .price-item.price-item--regular").text(S_comp);
    $(".product-sticky-sec .price-item--sale.price-item--last").html(S_price);
    setTimeout(function () {
        if (
            $(
                ".productDetailWrap .product-form__buttons .product-form__submit"
            ).is(":disabled")
        ) {
            $(".product-sticky-sec .product-sticky-button").attr(
                "disabled",
                true
            );
            $(".product-sticky-sec .product-sticky-button").text(
                $(
                    ".productDetailWrap .product-form__buttons .product-form__submit"
                ).text()
            );
        }
    }, 500);
});

$(document).ready(function () {
    $(".collection ul").addClass("twocol");
    $(".grid_layout_one").click(function () {
        $(".collection ul").removeClass("twocol");
        $(".collection ul").addClass("onecol");
        $(".grid_layout_two").removeClass("active");
        $(".grid_layout_one").addClass("active");
        reloadProductCarrousels();
    });

    $(".grid_layout_two").addClass("active");
    $(".grid_layout_two").click(function () {
        $(".collection ul").removeClass("onecol");
        $(".collection ul").addClass("twocol");
        $(".grid_layout_one").removeClass("active");
        $(".grid_layout_two").addClass("active");
        reloadProductCarrousels();

    });
});

$(document).ready(function () {
    $(".account-tab-section p.appended_text").click(function () {
        $(this).siblings("ul").slideToggle();
    });
});

$(document).ready(function () {
    $(".address_class_main").hide();
    $(
        ".account-tab-section .account-tab-inner .account-tab-right button[aria-expanded]"
    ).click(function () {
        var target_btn = $(this).attr("data-address-id");
        $(".address_class_main").each(function () {
            if ($(this).attr("data-address-id") == target_btn) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });
    $(".addresses form button[type]").click(function (e) {
        e.preventDefault();
        $(this).parents(".address_class_main").hide();
    });
});

$(document).ready(function () {
    $(".product-notify.product_sold_out").click(function () {
        $("button.restock-alerts-notify-button").trigger("click");
    });
});

$(window).on("load", function () {
    if ($("sticky-header.header-wrapper").offset().top > 45) {
        $(".shopify-section-header-sticky").addClass("scrolled-past-header");
    } else {
        $(".shopify-section-header-sticky").removeClass("scrolled-past-header");
    }
});

$(document).ready(function () {
    $(".register-form input#RegisterForm-DNI").on("input", function () {
        var inputValue = $(this).val();
        var maxLength = 12;

        if (inputValue.length > maxLength) {
            $(this).val(inputValue.slice(0, maxLength)); // Truncate the input
            $("#errorText").text("Maximum 12 digits allowed.");
        } else {
            $("#errorText").text(""); // Clear error message
        }
    });

    document.onkeydown = function (evte) {
        if (
            evte.keyCode == 27 &&
            $(".restock-alerts-modal-wrapper").is(":visible")
        ) {
            //27 is the code for escape
            $(".modalCloseButtonWrapper").trigger("click");
        }
        if (evte.keyCode == 27 && $(".zify-sc-light-modal").is(":visible")) {
            //27 is the code for escape
            $(".zify-sc-light-modal-close-icon").trigger("click");
        }
    };
});
$(document).ready(function () {
    $(".product__accordion details").on("click", function () {
        //e.preventDefault();
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            //$(this).find('summary').attr('aria-expanded', 'false');
        } else {
            //$(".product__accordion details").removeClass("active");
            //$(".accordion__content").slideUp(500);
            //$('.product__accordion details summary').attr('aria-expanded', 'false');
            $(this).addClass("active");
            //$(this).find('summary').attr('aria-expanded', 'true');
        }
    });
});

$(document).ready(function () {
    $(
        ".account-tab-section.addresses .myAddressTabMain li>button:first-of-type, .account-tab-section .account-block-box.add-details-box button"
    ).click(function () {
        setTimeout(function () {
            $("html, body").animate(
                {
                    scrollTop:
                        $(".account-tab-section form:visible").offset().top -
                        200,
                },
                1000
            );
        }, 500);
        return false;
    });
});

// header icon favorites counter update js
$(document).ready(function () {
    if (
        $(
            ".header-wrapper span.wishlist-h-count.wishlist-total-count"
        ).text() == 0
    ) {
        $(".header-wrapper span.wishlist-h-count.wishlist-total-count").hide();
        $(".header-wrapper span.wishlist-h-count.wishlist-total-count")
            .parents(".header-wrapper .header__icon.h-wishlist-icon")
            .css("margin-right", "0px");
    } else {
        $(".header-wrapper span.wishlist-h-count.wishlist-total-count").show();
        $(".header-wrapper span.wishlist-h-count.wishlist-total-count")
            .parents(".header-wrapper .header__icon.h-wishlist-icon")
            .css("margin-right", "25px");
    }
    $(".wishlist-total-count").on("DOMSubtreeModified", function () {
        if ($(this).text() == "0") {
            $(this).hide();
            $(this)
                .parents(".header-wrapper .header__icon.h-wishlist-icon")
                .css("margin-right", "0px");
        } else {
            $(this).show();
            $(this)
                .parents(".header-wrapper .header__icon.h-wishlist-icon")
                .css("margin-right", "25px");
        }
    });
});


$(document).ready(function () {
    try {
        // Obtener el valor inicial de "33.51" desde el JSON
        var initialTotal = parseFloat(
            "{{ " + settings.free_shipping_price + " | t }}".replace(",", ".")
        );

        // Función para obtener el valor numérico del precio del producto
        function getProductPrice() {
            var productPriceText = $(".price.price--end").text();
            // Extraer el valor numérico y convertirlo en un número
            var productPrice = parseFloat(
                productPriceText.replace("€", "").trim()
            );
            return productPrice;
        }

        // Función para actualizar el valor inicial y mostrar el resultado
        function updateTotalAndDisplay() {
            var productPrice = getProductPrice();
            var newTotal = (initialTotal - productPrice).toFixed(2); // Restar el precio del producto

            // Actualizar el valor en el JSON
            initialTotal = newTotal;

            // Actualizar el contenido del <span> con el nuevo total
            $(
                ".cart-drawer .drawer_heading_contents.deactivate_codes_mini .card-price"
            ).text(newTotal + " €");

            // Verificar si el valor llegó a 0 para mostrar el mensaje de freeshiping
            if (newTotal <= 0) {
                console.log("El valor llegó a 0");
                $(
                    ".cart-drawer .drawer_heading_contents.deactivate_codes_mini"
                ).hide();
                $(
                    ".cart-drawer .drawer_heading_contents.active_codes_mini"
                ).show();
            } else {
                console.log("El valor NO llegó a 0");
                $(
                    ".cart-drawer .drawer_heading_contents.deactivate_codes_mini"
                ).show();
                $(
                    ".cart-drawer .drawer_heading_contents.active_codes_mini"
                ).hide();
            }
        }

        // Llamar a la función inicialmente
        updateTotalAndDisplay();

        // Utilizar el evento cart.updated para detectar cambios en el carrito
        $(document).on("cart.updated", function () {
            console.log("Se ha actualizado el carrito");
            updateTotalAndDisplay();
        });
    } catch (e) {}
});

//Cambios izan

//Abrir el menú al hacer click en productos
document.addEventListener(
    "DOMContentLoaded",
    function () {
        document
            .querySelectorAll(".header__inline-menu .list-menu li a")
            ?.forEach((e) => {
                if (e.href.includes("#openmenu")) {
                    e.href = "";
                    e.addEventListener(
                        "click",
                        function (event) {
                            event.stopPropagation();
                            event.preventDefault();
                            $("#menu-drawer").css({
                                position: "absolute",
                                transform: "translate(0)",
                                visibility: "visible",
                                opacity: "1",
                            });
                            $("#menu-drawer").addClass("active");
                            $("body").addClass("overlay_class");
                        },
                        false
                    );
                }
            });
    },
    false
);

//Cambio de fotos en el selector de variantes en la colección
function swatchesEvent() {
    const swatches = document.querySelectorAll(
        ".product-card-wrapper .swatches li[data-product-id]"
    );
    swatches.forEach((swatch) => {
        swatch.addEventListener(
            "click",
            () => handleSwatchClick(swatch),
            false
        );
    });
}

function handleSwatchClick(swatch) {
    const {
        productId,
        productUrl,
        variantPrice,
        variantCompareAtPrice,
        variantPremiumPrice,
        discountedPrice,
        standardPrice,
        isSalesPrice,
        discountPriceTag,
        discount
    } = swatch.dataset;

    const swatchParent = swatch.parentNode;
    swatchParent
        .querySelectorAll("li")
        .forEach((li) => li.classList.remove("active"));
    swatch.classList.add("active");

    const cardWrapper = swatch.closest(".product-card-wrapper");
    cardWrapper
        .querySelectorAll(
            ".card__media img, .product-form .collection_product_variant label"
        )
        .forEach((img) => {
            img.style.display =
                img.getAttribute("data-product-id") ===
                swatch.getAttribute("data-product-id")
                    ? "flex"
                    : "none";
        });

    cardWrapper.querySelectorAll("a").forEach((anchor) => {
        anchor.href = productUrl;
    });

    const gridItem = swatch.closest(".grid__item");
    updateSliderForSwatch(gridItem, swatch);

    const saleBadgeEl = cardWrapper.querySelector(".badge__sale");
    const quickBuyElArray = cardWrapper.querySelectorAll(".quick-add");
    const priceNormalEl = cardWrapper.querySelector(".price-item--regular");
    const salePriceEl = cardWrapper.querySelector(".price-item--sale");

    //update prices
    //update sale badge
    if (discount > 0) {
        salePriceEl.classList.add("sale_color");
        saleBadgeEl.textContent = `-${discount}%`;
        toggleHidden(saleBadgeEl, false);
    } else {
        salePriceEl.classList.remove("sale_color");
        toggleHidden(saleBadgeEl, true);
    }

    salePriceEl.textContent = discountedPrice;
    if (discountedPrice !== variantCompareAtPrice) {
        priceNormalEl.style.display = "inline-block";
        priceNormalEl.textContent = standardPrice;
        salePriceEl.innerHTML = `${discountedPrice} <b>${discountPriceTag}</b>`;
    } else {
        priceNormalEl.style.display = "none";
    }

    quickBuyElArray.forEach((el) =>
        toggleHidden(el, el.dataset.productId !== productId)
    );

    function toggleHidden(el, bool) {
        if (bool) {
            return el.classList.add("hidden");
        }
        return el.classList.remove("hidden");
    }
}

function updateSliderForSwatch(gridItem, swatch) {
    const slider = $(gridItem).find(".slick-slider");
    slider.slick("slickGoTo", 0);
    slider.slick("slickUnfilter");
    slider.slick(
        "slickFilter",
        `[data-product-id='${swatch.dataset.productId}']`
    );
    slider.find(".slick-track img").css("display", "block");
}

/*show carousel multicolumn arrows*/
function loadProductCarrousels() {
    const carrouseles = document.querySelectorAll(
        ".collection #product-grid .grid__item .card__media .media:not(.slick-initialized)"
    );

    carrouseles.forEach(function (slider) {
        const gridItem = slider.closest(".grid__item");

        const slidesToShow = gridItem.classList.contains("show-multicolumn")
            ? 2
            : 1;

        const nextButton = gridItem.querySelector(".next-slide");
        const prevButton = gridItem.querySelector(".prev-slide");

        $(slider)
            .slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow,
                slidesToScroll: 1,
                arrows: true,
                adaptiveHeight: false,
                autoplay: false,
                autoplaySpeed: 3000,
                draggable: true,
                nextArrow: nextButton,
                prevArrow: prevButton,
            })
            .slick(
                "slickFilter",
                "[data-product-id='" + $(gridItem).data("product-id") + "']"
            );
        //!this changes slide on hover, removed per request of client
/*         $(gridItem).hover(
            function () {
                $(slider).slick("slickNext");
            },
            function () {
                $(slider).slick("slickPrev");
            }
        ); */
    });

    const hideCarrouseles = $(
        "#product-grid .grid__item.hide-multicolumn .card__media .media"
    );
    hideCarrouseles.slick("unslick");
}

function reloadProductCarrousels(){
  const carrouseles = document.querySelectorAll(
    ".collection #product-grid .grid__item .card__media .media.slick-initialized"
  );

  $(carrouseles).slick('setPosition');

}

//sale filter
document.addEventListener("DOMContentLoaded", () => {
    const showOnlySaleEl = document.getElementById("show-only-sale");
    const showOnlySaleElMobile = document.getElementById(
        "show-only-sale-mobile"
    );
    if (!showOnlySaleEl || !showOnlySaleElMobile) return;

    const checkIfOnSale = (el) =>
        el.querySelector(".price-item--sale.sale_color") ? true : false;

    const removeNonSaleCards = (container) =>
        container.querySelectorAll(".grid__item").forEach((el) => {
            if (showOnlySaleEl.checked) {
                el.classList.toggle("hidden", !checkIfOnSale(el));
                if (el.classList.contains("show-multicolumn")) {
                    el.classList.replace(
                        "show-multicolumn",
                        "hide-multicolumn"
                    );
                }
            } else {
                el.classList.remove("hidden");
                el.classList.replace("hide-multicolumn", "show-multicolumn");
            }
            loadProductCarrousels();
        });

    const updateDOM = () => {
        console.log("updateDOM");
        const container = document.getElementById("product-grid");
        removeNonSaleCards(container);
    };

    showOnlySaleElMobile.addEventListener("change", (e) => {
        showOnlySaleEl.checked = showOnlySaleElMobile.checked;
        e.stopImmediatePropagation();
        updateDOM();
    });
    showOnlySaleEl.addEventListener("change", (e) => {
        showOnlySaleElMobile.checked = showOnlySaleEl.checked;
        e.stopImmediatePropagation();
        updateDOM();
    });

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach((node) => {
                    if (
                        node.nodeType === 1 &&
                        (node.id === "product-grid" ||
                            node.classList.contains("grid__item"))
                    ) {
                        updateDOM();
                    }
                });
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

//Scroll infinito
if (window.location.pathname.includes("/collections/")) {
    function active_infinite_scroll() {
        let page = 2;
        const product_grid = document.querySelector(".product-grid-container");
        const product_body = document.querySelector("body");
        const product_pages = parseInt(product_grid.getAttribute("pages"));
        let loading_more_products = document.querySelector(
            ".loading-more-products"
        );

        let lastScrollTop = 0;
        let scrollEnd = false;
        product_body.onscroll = (e) => {
            let scrollTop = document.documentElement.scrollTop;
            if (scrollTop < lastScrollTop) {
                // upscroll
                return;
            }
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
            if (
                scrollTop + window.innerHeight >=
                    product_grid.scrollHeight - 1200 &&
                scrollEnd == false &&
                product_pages >= page
            ) {
                scrollEnd = true;
                loading_more_products.style.display = "block";

                let current_url = new URL(window.location.href);
                current_url.searchParams.set("page", page);
                console.log(current_url);

                fetch(current_url)
                    .then((res) => res.text())
                    .then((response) => {
                        const parser = new DOMParser();
                        const html = parser.parseFromString(
                            response,
                            "text/html"
                        );
                        const new_elements = Array.from(
                            html.querySelectorAll(
                                ".product-grid-container ul#product-grid > li"
                            )
                        ).filter((el) =>
                            document.getElementById(el.id) ? false : true
                        );

                        let product_grid_list =
                            product_grid.querySelector("ul#product-grid");
                        new_elements.forEach((ne) => {
                            product_grid_list.appendChild(ne);
                        });
                        $(
                            ".product-grid-container #product-grid .collection_product_variant label"
                        ).click(function () {
                            $(this).siblings().removeClass("active");
                            $(this).addClass("active");
                            const form = $(this).parent(".collection_product_variant").next("form");
                            form.find('input[name="id"]').attr(
                                "value",
                                $(this).attr("data_variant_id")
                            );
                            form.find('button[type="submit"]').click();
                        });

                        try {
                            swatchesEvent();
                        } catch (error) {
                            console.log(error);
                        }
                        try {
                            loadProductCarrousels();
                        } catch (error) {
                            console.log(error);
                        }

                        page++;
                        loading_more_products.style.display = "none";
                        scrollEnd = false;
                    });
            }
        };
    }
}

document.addEventListener("DOMContentLoaded", function () {
    swatchesEvent();
    loadProductCarrousels();
    try {
        active_infinite_scroll();
    } catch (error) {}
});

/*Funcionalidades JUD*/

/*Sección inspiración y menú*/
document.addEventListener("DOMContentLoaded", function () {
    const menuSection = document.getElementById("menuSection");
    if (!menuSection) return;

    function mergeContainers(selector) {
        const sections = document.querySelectorAll(selector);
        if (!sections[1]) return;

        let combinedHTML = sections[0].innerHTML;

        sections.forEach((section, index) => {
            if (index === 0) return;
            combinedHTML += section.innerHTML;
            section.remove();
        });

        sections[0].innerHTML = combinedHTML;
    }
    mergeContainers(".section-collection-inspiracion .cardImg-row");

    const blocks = document.querySelectorAll(".inspiration-card");

    function parseCategories(block) {
        try {
            block.categories = JSON.parse(block.dataset.categories).map(
                (num) => {
                    const number = Number(num);
                    if (Number.isNaN(number)) throw new Error("Not a number");
                    return number;
                }
            );
        } catch (e) {
            return (block.querySelector(
                ".cardImg-content"
            ).innerHTML = `<span style="color: red; font-size: 22px;">WARNING: invalid categories</span>`);
        }
    }

    blocks.forEach(parseCategories);

    function showOnlyCardsInCategory(id) {
        const categoryId = Number(id);
        if (Number.isNaN(categoryId)) throw new Error("Id is not a number");

        blocks.forEach((block) => {
            if (block.categories.includes(categoryId)) {
                return block.classList.remove("hidden");
            }
            return block.classList.add("hidden");
        });
    }

    menuSection.querySelectorAll(".menuInpiracion li")?.forEach((li) => {
        li.addEventListener("click", () =>
            showOnlyCardsInCategory(li.dataset.category)
        );
    });
});

/*arrows para desplazamiento de menú en responsive*/
document.addEventListener("DOMContentLoaded", function () {
    try {
        const menuSection = document.getElementById("menuSection");
        const menu = menuSection.querySelector(".menuInpiracion");
        const arrowLeft = menuSection.querySelector(".arrow-left");
        const arrowRight = menuSection.querySelector(".arrow-right");

        // Definir el desplazamiento actual
        let scrollPosition = 0;

        // Ancho del desplazamiento en píxeles
        const scrollWidth = 100;

        // Agregar evento de clic a la flecha izquierda
        arrowLeft.addEventListener("click", function () {
            scrollPosition -= scrollWidth;
            if (scrollPosition < 0) {
                scrollPosition = 0;
            }
            menu.style.transform = `translateX(-${scrollPosition}px)`;
        });

        // Agregar evento de clic a la flecha derecha
        arrowRight.addEventListener("click", function () {
            const maxScroll = menu.scrollWidth - menu.clientWidth;
            scrollPosition += scrollWidth;
            if (scrollPosition > maxScroll) {
                scrollPosition = maxScroll;
            }
            menu.style.transform = `translateX(-${scrollPosition}px)`;
        });
    } catch (e) {}
});

/* PopUp SELECTOR TIENDA */
document.addEventListener("DOMContentLoaded", function () {
    if (!haVisitadoPagina()) {
        mostrarPopup();
    }
});

function haVisitadoPagina() {
    return document.cookie.includes("popUpVisitado=true");
}

function mostrarPopup() {
    try {
        document.getElementById("overlay_seleShop").style.display = "flex";
        document.getElementById("popup_seleShop").style.display = "flex";

    } catch (error) {

    }
}

function cerrarPopup() {
    document.getElementById("overlay_seleShop").style.display = "none";
    document.getElementById("popup_seleShop").style.display = "none";

    document.cookie =
        "popUpVisitado=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/";
}

/* En caso de que quiera guardar la cookie almacenar la cookie*/

function redirigir() {
    var seleccion = document.getElementById("opciones").value;

    switch (seleccion) {
        case "opcion1":
            window.location.href =
                "https://textura-interiors-b2c.myshopify.com/";
            break;
        case "opcion2":
            window.location.href = "https://textura-canarias.myshopify.com/";
            break;
    }
}




//recreate cart after login
/* subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    const cart = await fetch('/cart.js').then(data => data.json());
    window.sessionStorage.setItem('cartToken', cart.token)
});

function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return decodeURIComponent(cookie.substring(name.length + 1));
      }
    }
    return null;
}

function setCookie(name, value, daysToExpire = 3) {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    const expires = `expires=${expirationDate.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
}

function checkCartCookie(){
    const cookieCart = getCookie('cart');
    const sessionCart = sessionStorage.getItem('cartToken');

    if((cookieCart && sessionCart) && cookieCart !== sessionCart) {
        setCookie('cart', sessionCart);
        publish(PUB_SUB_EVENTS.cartUpdate);
    }
}

checkCartCookie(); */

window.addEventListener('pageshow', function(event) {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pageview' });
});